import * as globals from '@wandb/weave/common/css/globals.styles';
import {Button} from 'semantic-ui-react';
import styled from 'styled-components';

export const SuccessContainer = styled.div`
  background-color: ${globals.white};
  color: ${globals.textPrimary};
  width: 420px;
  padding: 40px 32px;
`;

export const SuccessHeader = styled.div`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

export const SuccessContent = styled.div`
  margin: 24px 0;
  font-size: 18px;
  line-height: 24px;
`;

export const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const CloseModalButton = styled.div`
  &&&&& {
    color: ${globals.MOON_800};
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }
`;

export const ConfirmButton = styled(Button)`
  &&&&& {
    background-color: ${globals.TEAL_550};
    color: ${globals.white};
    font-size: 16px;
    font-weight: 600;
    padding: 8px 12px;
    border-radius: 4px;
    margin-right: 16px;
    &:hover {
      background-color: ${globals.TEAL_500};
      cursor: pointer;
    }
  }
`;

export const TermsAndPrivacyContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const UpgradeOrCancelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
`;
